import { push } from 'connected-react-router'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { RootState } from '../../app/store'
import { pages } from '../../constants/pages'
import NtfExercises from './components/NtfExercises'
import { next, end, requestQuit, loadCards  } from './ntfSlice'
import { Gender, SelectedLevelAndGender } from './ntfHelper'

const NtfExercisesConnect = () => {
  const dispatch = useAppDispatch()
  const { status, exercises, cards, userScores, startTime, endTime } = useAppSelector((state: RootState) => state.nameTheFace)
 
  const handleNext = () => {
    dispatch(next())
    if (status === 'completed') {
      dispatch(push(pages.cognitiveExercises.route))
    }
  }

  const handleLoadCards = (level:number, gender: Gender | undefined) => {
    const payload: SelectedLevelAndGender = { level }
    if (gender !== undefined) { payload.gender = gender }
    dispatch(loadCards(payload))
  }

  const handleEndExercise = (finished: boolean, attempts: number) => {
    dispatch(end({ finished, attempts }))
  }

  const handleQuit = (route: string) => {
    dispatch(requestQuit(route))
  }

  return (
    <NtfExercises 
      status={status}
      next={handleNext}
      exercises={exercises}
      cards={cards}
      userScores={userScores}
      startTime={startTime}
      endTime={endTime} 
      loadCards={handleLoadCards}
      endExercise={handleEndExercise}
      backTo={handleQuit}
    />
  )
}

export default NtfExercisesConnect